export default __webpack_public_path__ + "static/media/remove_photo_red.bb00a79e.svg";